import { TabGroup } from "@headlessui/react";
import { ReactNode, useCallback } from "react";
import { NavigationBarSubHeader } from "../navigation/NavigationBar";
import { useTabbedListScrollRestoration } from "./useTabbedListScrollRestoration";

export const TabbedListGroup = ({
  children,
  onChange,
  selectedIndex,
}: {
  children: ReactNode;
  onChange: (index: number) => void;
  selectedIndex: number;
}) => {
  const saveScrollPosition = useTabbedListScrollRestoration(selectedIndex);
  const handleChange = useCallback(
    (index: number) => {
      saveScrollPosition();
      onChange(index);
    },
    [onChange, saveScrollPosition],
  );

  return (
    <TabGroup selectedIndex={selectedIndex} onChange={handleChange}>
      {children}
    </TabGroup>
  );
};

export const TabbedListHeader = ({ children }: { children: ReactNode }) => (
  <NavigationBarSubHeader className="border-gray-300 bg-white">
    {children}
  </NavigationBarSubHeader>
);
